module.exports = __webpack_public_path__ + "static/media/social.9f3e45d5.jpg";